import React from 'react'
import Tooltip from '~/components/common/Tooltip'
import { formatRelative, formatDistance } from '~/utils/dateFns'

type Props = { date: Date }

const DateTooltip: React.FC<Props> = ({ date }) => {
  return (
    <Tooltip content={formatRelative(new Date(date))}>
      <span>{formatDistance(new Date(date))}</span>
    </Tooltip>
  )
}

export default DateTooltip
